import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import { globalBuilder } from '../../archbuilder/GlobalBuilder';

export const Home: React.FC = () => {
  const { theme, setTheme, setThemes } = useContext(ThemeContext);
  const [themeImageIndex, setThemeImageIndex] = useState(0);

  useEffect(() => {
    setThemes(['pages']);
  }, []);

  useEffect(() => {
    setThemeImageIndex(
      theme === 'light' ? 2 : theme === 'dark' ? 1 : theme === 'thief' ? 0 : -1,
    );
  }, [theme]);

  const images: string[] = [
    `${process.env.PUBLIC_URL}/images/logo.png`,
    `${process.env.PUBLIC_URL}/images/moon.png`,
    `${process.env.PUBLIC_URL}/images/sun.png`,
  ];

  return globalBuilder.Home(images[themeImageIndex]);
};
